import React from 'react';

import { Chip, Typography, capitalize } from '@mui/material';

import { useIntl } from '@klokhuis/core/Intl';
import { ListingChipLabelTranslations } from '@klokhuis/modules/Properties/translations';
import { ListingChipLabels } from '@klokhuis/modules/Properties/types';

import styles from './ListingChip.module.css';

interface ListingChipProps {
  label: ListingChipLabels;
}

export const ListingChip = ({ label }: ListingChipProps): JSX.Element => {
  const { T } = useIntl();
  return (
    <Typography
      component={Chip}
      variant="subtitle3"
      label={capitalize(T(ListingChipLabelTranslations[label]))}
      className={styles.root}
    />
  );
};
